import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { ToParam } from '../_helpers/alertsFilterParams';
import { AlertsDashboardAction } from '../alertsDashboard.action';

export const changeDashboardAlertsToEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(AlertsDashboardAction.updateTo),
  mergeMap((payload) => {
    return [
      payload
        ? RouterAction.addParam(ToParam.nameAndValue(payload.valueOf()))
        : RouterAction.removeParam(ToParam.name),
    ];
  }),
);
